import { RGBColor } from "../data/Color";

export namespace consts {
    export namespace Colors {
        export const RED = new RGBColor(255, 0, 0);
        export const BLUE = new RGBColor(0, 0, 255);
        export const GREEN = new RGBColor(0, 255, 0);
        export const BLACK = new RGBColor(0, 0, 0);
        export const WHITE = new RGBColor(255, 255, 255);
    }
}